function NotFound() {
    return (<div className="uk-container">
        <h3>Erreur 404 - Page non trouvée</h3>
    </div>);
}

export default NotFound;